import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'material-ui/Tooltip';
import {withStyles} from 'material-ui/styles';
import Info from 'material-ui-icons/InfoOutline';
import Select from 'react-select';
import {
    TableCell,
    TableRow,
} from 'material-ui/Table';
import moment from 'moment';
import axios from "axios";
import * as host from "../../../host/host";
import {CircularProgress} from 'material-ui/Progress';
import {DatePicker} from 'material-ui-pickers';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import ruLocale from 'date-fns/locale/ru';

import {MuiThemeProvider, createMuiTheme} from 'material-ui';

moment.locale('ru');

const materialTheme = createMuiTheme({
    overrides: {
        typography: {
            // Tell Material-UI what's the font-size on the html element is.
            fontSize: '1.5rem'
        },
        DateTimePicker: {
            fontSize: '1.5rem'
        },
        MuiPickersToolbar: {
            toolbar: {
                fontSize: '1.5rem'
            }
        },
        MuiPickersCalendarHeader: {
            daysHeader: {
                fontSize: '1.5rem'
            },
            switchHeader: {
                fontSize: '1.5rem'
            },
            dayLabel: {
                fontSize: '1.5rem'
            }
        },
        MuiPickersDay: {
            day: {
                fontSize: '1.5rem'
            },
            selected: {
                fontSize: '1.5rem'
            },
            current: {
                fontSize: '1.5rem'
            }
        },
        MuiTypography: {
            root: {
                fontSize: '1.5rem'
            },
            body1: {
                fontSize: '2rem',
                lineHeight: '1.63em'
            }
        }
    }
});

const styles = theme => ({
    activeSortLabel: {
        color: 'white !important',
    },
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        backgroundColor: '#f5f5f5'
    },
    table: {
        minWidth: 800
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    paginationColor: '#ffffff',
    tableRoot: {},
    filterTitle: {
        fontSize: '15px',
        margin: '0 0 0 10px'
    },
    filterTitleMonth: {
        fontSize: '15px',
        // margin: '0 0 0 10px',
        [theme.breakpoints.up('lg')]: {
            float: 'right',
            paddingRight: '10px',
        },
        [theme.breakpoints.down('md')]: {
            paddingLeft: '10px',
        }
    },
    moreFilters: {
        // fontSize: '15px',
        // margin: '0 0 0 10px',
        cursor: 'pointer'
    },
    fontSizeDefault: {
        fontSize: '15px',
        // border: '1px solid #beb7b7 ',
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '3px',
        padding: '5px',
        // marginBottom: '15px'
    },
    fontSizeTime: {
        fontSize: '12px',
        marginTop: '6px',
        marginRight: '16px',
        marginBottom: '0px'
    },
    fontSizeCells: {
        fontSize: '14px',
        padding: 12,
        textAlign: 'center'
        // paddingRight: '0px',
        // paddingLeft: '0px'
    },
    fontSizeIcons: {
        color: 'rgb(117, 117, 117)',
        cursor: 'pointer'
    },
    fontSizeHeadersList: {
        fontSize: '13px',
        lineHeight: '14px',
        fontWeight: '500'
    },
    fontSizeHeadersListCategory: {
        fontSize: '13px',
        lineHeight: '14px',
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '12px',
            paddingRight: '0px'
        },
        fontWeight: '500'
    },
    tooltipComment: {
        fontSize: '13px',
        // maxWidth: '335px'
    },
    primaryListItem: {
        fontSize: '11px !important',
    },
    fontSizeIconsFilter: {
        width: '20px',
        height: '20px'
    },
    gridList: {
        [theme.breakpoints.up('md')]: {
            padding: '0'
        }
    },
    filterRow: {
        width: '100%',
        display: 'inline-flex',
        right: '0px',
        float: 'left',
        marginTop: '10px',
        [theme.breakpoints.up('lg')]: {
            float: 'right',
        }
    },
    filterRowAccount: {
        width: '100%',
        display: 'inline-flex',
        right: '0px',
        float: 'left',
        marginTop: '10px',
        [theme.breakpoints.up('lg')]: {
            float: 'right',
            marginRight: '40px'
        },
    },
    selectFilter: {
        [theme.breakpoints.down('md')]: {
            paddingRight: '20px'
        },
    },
    filterButton: {
        float: 'right',
        margin: '20px 10px 5px 10px'
    },
    modal: {
        position: 'absolute',
        border: '1px solid #e5e5e5',
        backgroundColor: '#fff',
        boxShadow: '0 5px 15px rgba(0, 0, 0, .5)',
        padding: '20px',
        [theme.breakpoints.down('xs')]: {
            top: '1%',
            left: '10%',
            height: '95%',
            width: '80%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('sm')]: {
            top: '5%',
            left: '20%',
            height: '90%',
            width: '60%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('md')]: {
            top: '10%',
            left: '10%',
            height: '570px',
            width: '80%',
            overflowY: 'none',
        },
        [theme.breakpoints.up('lg')]: {
            top: '5%',
            left: '15%',
            height: '570px',
            width: '70%',
            overflowY: 'none',
        },
    },
    modalTransfer: {
        position: 'absolute',
        border: '1px solid #e5e5e5',
        backgroundColor: '#fff',
        boxShadow: '0 5px 15px rgba(0, 0, 0, .5)',
        padding: '20px',
        [theme.breakpoints.down('xs')]: {
            top: '1%',
            left: '10%',
            height: '85%',
            width: '80%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('sm')]: {
            top: '5%',
            left: '20%',
            height: '70%',
            width: '60%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('md')]: {
            top: '10%',
            left: '10%',
            height: '570px',
            width: '80%',
            overflowY: 'none',
        },
        [theme.breakpoints.up('lg')]: {
            top: '5%',
            left: '15%',
            height: '570px',
            width: '70%',
            overflowY: 'none',
        },
    },
    loader: {
        [theme.breakpoints.up('md')]: {
            /*left: '-220px'*/
        },
        width: '150px',
        height: '150px',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        margin: 'auto'
    },
    svgDeterminate: {
        animation: 'mui-progress-circular-rotate 1.4s linear infinite',
        transform: 'rotate(0deg)',
        // position: 'absolute',
        width: '150px',
        // marginLeft: '5%',
        // marginTop: '30px',
        // [theme.breakpoints.up('sm')]: {
        //     left: '50%',
        // },
        // [theme.breakpoints.down('sm')]: {
        //     left: '35%',
        // },
        // [theme.breakpoints.down('xs')]: {
        //     left: '25%',
        // },
        // transform: 'translate(-50%, -50%)',
    },
    svgDeterminateCell: {
        animation: 'mui-progress-circular-rotate 1.4s linear infinite',
        transform: 'rotate(0deg)',
        width: '30px',
    },
    rootCircularProgress: {
        width: 'auto !important',
        height: 'auto !important'
    },
    mobileHeaders: {
        fontSize: '16px'
    },
    mobileListItem: {
        fontSize: '15px',
        fontWeight: '410',
        marginLeft: '30px',
        // [theme.breakpoints.down('xs')]: {
        //     marginLeft: '15px',
        // },
    },
    mobileListItemValue: {
        fontSize: '15px',
        marginRight: '10px'
    },
    mobileHeaderSum: {
        fontSize: '16px',
        fontWeight: '500'
    },
    gridContainerMobile: {
        marginBottom: '15px'
    },
    accountValue: {
        paddingTop: '5px',
        fontSize: '12px',
        marginBottom: '0px'
    },
    accountName: {
        marginBottom: '0px',
        marginTop: '17px'
    },
    fontSizeDate: {
        marginBottom: '0px',
        marginTop: '16px'
    },
    listItemMobile: {
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '10px',
            paddingRight: '10px'
        },
    },
    iconMobile: {
        [theme.breakpoints.down('xs')]: {
            marginRight: '0px'
        },
    },
    incomeIcon: {
        color: 'rgb(102, 187, 106)'
    },
    consumptionIcon: {
        color: 'rgb(239, 154, 154)'
    },
    incomeIconMobile: {
        color: 'rgb(102, 187, 106)',
        [theme.breakpoints.down('xs')]: {
            marginRight: '0px'
        },
    },
    consumptionIconMobile: {
        color: 'rgb(239, 154, 154)',
        [theme.breakpoints.down('xs')]: {
            marginRight: '0px'
        },
    },
    incomeSum: {
        color: 'rgb(102, 187, 106)',
        fontWeight: 500,
        fontSize: '14px',
        paddingRight: '0px',
        paddingLeft: '0px'
    },
    consumptionSum: {
        color: '#ff0000',
        fontSize: '14px',
        paddingRight: '0px',
        paddingLeft: '0px'
    },
    incomeSumMobile: {
        color: 'rgb(102, 187, 106)',
        fontWeight: 500,
        fontSize: '15px',
    },
    consumptionSumMobile: {
        color: '#ff0000',
        fontSize: '15px',
    },
    captionTablePagination: {
        fontSize: 14,
        paddingBottom: 0
    },
    selectTablePagination: {
        paddingRight: 25,
        paddingBottom: 0
    },
    selectIconTablePagination: {
        paddingBottom: 4
    },
    actionsTablePagination: {
        paddingBottom: 10,
        marginBottom: 10
    },
    selectItem: {
        fontSize: 16
    },
    selectItemCounterparty: {
        [theme.breakpoints.down('md')]: {
            margin: '0px 10px'
        },
        fontSize: 16
    }

});

class CompaniesRow extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getDate = this.getDate.bind(this);

        this.tariffChange = this.tariffChange.bind(this);
        this.handleTariffChange = this.handleTariffChange.bind(this);

        this.tariffTermChange = this.tariffTermChange.bind(this);
        this.handleTariffTermChange = this.handleTariffTermChange.bind(this);

        this.handleTooltipClick = this.handleTooltipClick.bind(this);
        this.handleTooltipUsersClick = this.handleTooltipUsersClick.bind(this);

        this.state = {
            changedTariff: {},
            changedTariffTerm: {},
            selectedDateTariffTerm: new Date(),

            openTooltip: false,
            openTooltipUsers: false,

            circular_progress_tariff: false,
            circular_progress_tariff_term: false
        };
    }

    getDate(date) {
        let dateFormat = new Date(date.split('T')[0]);
        let month = (dateFormat.getMonth() + 1 < 10) ? ("0" + (dateFormat.getMonth() + 1)) : (dateFormat.getMonth() + 1);
        let day = (dateFormat.getDate() < 10) ? ("0" + dateFormat.getDate()) : dateFormat.getDate();
        let dateStringFormat = day + "." + month + '.' + dateFormat.getFullYear();
        let resultData = {
            date: dateStringFormat,
            time: (date.split('T')[1]).split('.')[0]
        };
        return resultData;
    }

    tariffChange = company => event => {
        const _this = this;
        if (_this.state.changedTariff._id !== company._id) {
            _this.setState({
                changedTariff: company
            });
            console.log('open change tariff');
            event.stopPropagation();
        }
    };

    handleTariffChange(event) {
        const _this = this;
        _this.setState({
            circular_progress_tariff: true
        });
        let newTariff = Object.assign({}, _this.state.changedTariff);
        newTariff.tariff = Object.assign({}, event);
        _this.setState({
            changedTariff: newTariff
        }, function () {
            if (!_this.props.company.tariff || _this.state.changedTariff.tariff.value !== _this.props.company.tariff.value) {
                console.log('new tariff', _this.state.changedTariff);
                axios({
                    url: host.url + '/admin/set_company_tariff',
                    method: 'post',
                    data: {
                        company_id: _this.props.company._id,
                        tariff: _this.state.changedTariff.tariff
                    }
                }).then(function (response) {
                    _this.setState({
                        changedTariff: {_id: ''}
                    });
                    _this.props.getCompanies();
                    setTimeout(function () {
                        _this.setState({
                            circular_progress_tariff: false
                        });
                    }, 3500);
                    console.log(response);
                }).catch(function (error) {
                    console.log('tariff change', error);
                });
            }
            else {
                _this.setState({
                    changedTariff: {_id: ''}
                });
            }
        });
    }

    tariffTermChange = company => event => {
        const _this = this;
        if (_this.state.changedTariffTerm._id !== company._id) {
            _this.setState({
                changedTariffTerm: company,
                selectedDateTariffTerm: company.tariff_term ? new Date(company.tariff_term) : new Date()
            });
            console.log('open change tariff term');
            event.stopPropagation();
        }
    };

    handleTariffTermChange = (date) => {
        const _this = this;
        _this.setState({
            circular_progress_tariff_term: true
        });
        let newDate = Object.assign({}, _this.state.changedTariffTerm);
        let month = date.getMonth() + 1;
        let day = date.getDate();
        if (month.toString().length === 1) {
            month = '0' + month;
        }
        if (day.toString().length === 1) {
            day = '0' + day;
        }
        let fullDate = date.getFullYear() + '-' + month + '-' + day;
        newDate.tariff_term = fullDate;
        _this.setState({
            selectedDateTariffTerm: date,
            changedTariffTerm: newDate,
        }, function () {
            if (!_this.props.company.tariff_term || _this.props.company.tariff_term !== _this.state.changedTariffTerm.tariff_term) {
                console.log('send date', _this.state.changedTariffTerm);
                axios({
                    url: host.url + '/admin/set_company_tariff_term',
                    method: 'post',
                    data: {
                        company_id: _this.props.company._id,
                        tariff_term: _this.state.changedTariffTerm.tariff_term
                    }
                }).then(function (response) {
                    _this.setState({
                        changedTariffTerm: {_id: ''}
                    });
                    _this.props.getCompanies();
                    setTimeout(function () {
                        _this.setState({
                            circular_progress_tariff_term: false
                        });
                    }, 3500);
                    console.log(response);
                }).catch(function (error) {
                    console.log('tariff change', error);
                });
            }
            else {
                _this.setState({
                    changedTariffTerm: {_id: ''}
                });
            }
        });
    };

    handleTooltipClick() {
        const _this = this;
        _this.setState({
            openTooltip: !_this.state.openTooltip
        });
    }

    handleTooltipUsersClick() {
        const _this = this;
        _this.setState({
            openTooltipUsers: !_this.state.openTooltipUsers
        });
    }

    render() {
        const _this = this;
        const {classes} = this.props;
        // const isSelected = this.isSelected(_this.props.company._id);
        let create_date = _this.getDate(_this.props.company.creation_date);
        let last_transaction_date = _this.props.company.last_transaction_date ? _this.getDate(_this.props.company.last_transaction_date) : {
            date: '',
            time: ''
        };
        let tariff_term = _this.props.company.tariff_term ? _this.props.company.tariff_term.split('T')[0] : '';
        let days_left = moment(tariff_term).diff(moment(), 'days');
        let users = <div>{_this.props.company.users.map((user) => {
            return (
                <div key={user.user_id}>
                    {user.email}
                    <br/>
                </div>
            );
        })}</div>;
        return (
            <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                style={moment(tariff_term).isBefore(moment(), 'day') ? {backgroundColor: '##d9d9d9'} : _this.props.company.tariff.label === "I" ? {backgroundColor: '#ffe599'} : _this.props.company.tariff.label === "II" ? {backgroundColor: '#ffd966'} : _this.props.company.tariff.label === "III" ? {backgroundColor: '#f1c232'} : _this.props.company.tariff.label === "B" ? {backgroundColor: '#b4a7d6'} : _this.props.company.tariff.label === "T" ? {backgroundColor: '#c9daf8'} : null}
                id={_this.props.company._id}
            >
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.company.index}
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    <Tooltip
                        title={_this.props.company._id}
                        placement={'right'}
                        enterDelay={300}
                        classes={{tooltip: classes.tooltipComment}}
                        disableTriggerFocus={true}
                        disableTriggerHover={true}
                        disableTriggerTouch={true}
                        open={_this.state.openTooltip}
                    >
                        <Info style={{cursor: 'pointer'}}
                              onClick={() => {
                                  _this.handleTooltipClick();
                              }}
                        />
                    </Tooltip>
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    <p className={classes.fontSizeDate}>{create_date.date}</p>
                    <p className={classes.fontSizeTime}>{create_date.time}</p>
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.company.name}
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           onClick={_this.tariffChange(_this.props.company)}
                           style={{cursor: 'pointer', fontWeight: '500'}}
                           numeric>
                    {_this.state.changedTariff._id === _this.props.company._id ?
                        <Select
                            value={_this.state.changedTariff.tariff}
                            onChange={_this.handleTariffChange}
                            onBlur={() => {
                                _this.setState({
                                    changedTariff: {_id: ''}
                                });
                            }}
                            clearable={false}
                            displayEmpty
                            autoFocus
                            options={_this.props.tariff_options}
                        />
                        :
                        _this.state.circular_progress_tariff ?
                            <CircularProgress
                                className={classes.progress}
                                classes={{
                                    svgDeterminate: classes.svgDeterminateCell,
                                    root: classes.rootCircularProgress
                                }}
                                mode="determinate"
                                value={75}/> :
                            _this.props.company.tariff ?
                                <span>{_this.props.company.tariff.label}</span> : ''
                    }

                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           onClick={_this.tariffTermChange(_this.props.company)}
                           style={{cursor: 'pointer'}}
                           numeric>
                    {_this.state.changedTariffTerm._id === _this.props.company._id ?
                        <MuiPickersUtilsProvider utils={DateFnsUtils}
                                                 locale={ruLocale}>
                            <MuiThemeProvider theme={materialTheme}>
                                <div className='picker' style={{
                                    width: 90,
                                    paddingTop: 7,
                                    margin: '0px 5px'
                                }}>
                                    <DatePicker
                                        autoOk
                                        value={_this.state.selectedDateTariffTerm}
                                        onChange={this.handleTariffTermChange}
                                        autoFocus
                                        label="Дата"
                                        cancelLabel={'Отмена'}
                                        okLabel={'Выбор'}
                                        TextFieldComponent={'input'}
                                        className={classes.fontSizeDefault}
                                        format="DD.MM.YYYY"
                                        style={{
                                            width: '100%',
                                            marginBottom: 0,
                                            border: 'none'
                                        }}
                                    />
                                </div>
                            </MuiThemeProvider>
                        </MuiPickersUtilsProvider> :
                        _this.state.circular_progress_tariff_term ?
                            <CircularProgress
                                className={classes.progress}
                                classes={{
                                    svgDeterminate: classes.svgDeterminateCell,
                                    root: classes.rootCircularProgress
                                }}
                                mode="determinate"
                                value={75}/> :
                            <span
                                style={days_left > 6 ? {
                                    color: '#02b351',
                                    fontWeight: '500'
                                } : days_left <= 6 && days_left > 2 ? {
                                    color: 'rgb(218, 172, 40)',
                                    fontWeight: '500'
                                } : days_left <= 2 ? {color: '#ea2222', fontWeight: '500'} : null}
                            >
                             {tariff_term}
                          </span>
                    }
                </TableCell>

                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.company.owner_email && _this.props.company.owner_email.length > 20 ?
                        <Tooltip
                            title={_this.props.company.owner_email}
                            placement={'top'}
                            enterDelay={300}
                            classes={{tooltip: classes.tooltipComment}}
                        >
                            <div
                                style={{cursor: 'pointer'}}>{_this.props.company.owner_email.slice(0, 20)}..
                            </div>
                        </Tooltip> :
                        _this.props.company.owner_email
                    }
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {users ?
                        <Tooltip
                            title={users}
                            placement={'right'}
                            enterDelay={300}
                            classes={{tooltip: classes.tooltipComment}}
                            disableTriggerFocus={true}
                            disableTriggerHover={true}
                            disableTriggerTouch={true}
                            open={_this.state.openTooltipUsers}
                        >
                            <span style={{cursor: 'pointer'}}
                                  onClick={() => {
                                      _this.handleTooltipUsersClick();
                                  }}>{_this.props.company.employees_count}
                            </span>
                        </Tooltip> :
                        _this.props.company.employees_count
                    }
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.company.transactions_count}
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    <p className={classes.fontSizeDate}>{last_transaction_date.date}</p>
                    <p className={classes.fontSizeTime}>{last_transaction_date.time}</p>
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.company.transactions_seven_days}
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.company.transactions_fourteen_days}
                </TableCell>
                <TableCell className={classes.fontSizeCells}
                           numeric>
                    {_this.props.company.transactions_thirty_days}
                </TableCell>
            </TableRow>
        );
    }
}

CompaniesRow.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CompaniesRow);



// WEBPACK FOOTER //
// ./src/components/tabs/companies/CompaniesRow.js